<template>
  <v-dialog v-model="dialog" max-width="400px" persistent>
    <template #activator="{ on }">
      <div @click="!loading ? (dialog = true) : null">
        <v-row no-gutters>
          <v-col class="py-0" align="center">
            <mf-button label="Selecionar Tags" :loading="loading" data-cy="user-tags-button" @click="dialog = true" />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col align="left" class="pt-2">
            <v-chip v-for="tag in lazySelectedUserTags" :key="tag.tag" small close class="mr-1 mb-1" @click:close="unsetUserTag(tag)">
              {{ tag.tag }}
            </v-chip>
          </v-col>
        </v-row>
      </div>
    </template>
    <v-card>
      <v-card-title>
        <span class="mf-h6 primary-text">Selecionar tags de usuário</span>
      </v-card-title>
      <v-card-subtitle class="py-2">
        <span> O valor das tags de usuário é atualizado automaticamente de acordo com a integração durante a atualização da plataforma </span>
      </v-card-subtitle>
      <v-card-text>
        <v-row no-gutters>
          <v-col class="py-2">
            <mf-search v-model="search" placeholder="Buscar tag de usuário" hide-details />
          </v-col>
        </v-row>
        <v-row v-show="lazySelectedUserTags.length > 0" no-gutters>
          <v-col>
            <v-chip v-for="tag in lazySelectedUserTags" :key="tag.tag" small close class="mr-1 mb-1" @click:close="unsetUserTag(tag)">
              {{ tag.tag }}
            </v-chip>
          </v-col>
        </v-row>
        <div>
          <v-data-table
            v-model="localSelectedUserTags"
            :items="items"
            :headers="headers"
            item-key="tag"
            hide-default-footer
            disable-pagination
            show-select
            class="mt-2 row-pointer"
            fixed-header
            no-data-text="Nenhum resultado encontrado"
            data-cy="user-tags-table"
            height="400px"
          />
        </div>
      </v-card-text>
      <v-card-actions class="text-right">
        <v-row justify="end" no-gutters>
          <mf-button label="Cancelar" text class="mr-2" @click="cancel" />
          <mf-button label="Selecionar" class="mr-3" @click="confirm" />
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { diacriticSpaceSensitiveRegex } from '@/helpers/search'

export default {
  name: 'SelectUserTags',
  props: {
    userTags: {
      type: Array,
      default: () => [],
    },
    selectedUserTags: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dialog: false,
    lazySelectedUserTags: [],
    search: '',
    localSelectedUserTags: [],
  }),
  computed: {
    headers() {
      return [
        {
          text: 'Tag',
          value: 'tag',
          sortable: false,
        },
      ]
    },
    items() {
      if (this.search) {
        const searchRegex = diacriticSpaceSensitiveRegex(this.search)
        return this.userTags.filter((tag) => tag.tag.match(searchRegex))
      }
      return this.userTags
    },
  },

  watch: {
    selectedUserTags: {
      handler(value) {
        this.lazySelectedUserTags = value || []
        this.localSelectedUserTags = [...this.lazySelectedUserTags]
      },
      immediate: true,
    },
  },

  mounted() {
    this.lazySelectedUserTags = [...this.selectedUserTags]
    this.localSelectedUserTags = [...this.selectedUserTags]
  },

  methods: {
    unsetUserTag(tagToRemove) {
      this.lazySelectedUserTags = this.lazySelectedUserTags.filter((tag) => tag.tag !== tagToRemove.tag)
      this.localSelectedUserTags = this.localSelectedUserTags.filter((tag) => tag.tag !== tagToRemove.tag)
      this.$emit('update:selectedUserTags', this.lazySelectedUserTags)
    },
    cancel() {
      this.dialog = false
      this.localSelectedUserTags = [...this.lazySelectedUserTags]
    },
    confirm() {
      this.lazySelectedUserTags = [...this.localSelectedUserTags]
      this.$emit('update:selectedUserTags', this.lazySelectedUserTags)
      this.dialog = false
    },
  },
}
</script>
